import { INITIAL_STATE } from "../../constant";
import { checkAuth, getType } from "../actions";

export default function authReducers(state = INITIAL_STATE.auth, action) {
    switch (action.type) {
        case getType(checkAuth.setCurrentPage):
            return {
                ...state,
                currentPage: action.payload,
            };
        case getType(checkAuth.login):
            return {
                ...state,
                isLoggedIn: true,
            };
        // case getType(checkAuth.logout): // case 'getPostFailure'
        //     return {
        //         ...state,
        //         isLoading: false,
        //     };
        default:
            return state;
    }
}